/** **************************************
 * Request/API Call Constants
 *************************************** */
export const REPORTS_SHIFTS_SHIFT_SUMMARY_REQUEST =
  'REPORTS_SHIFTS_SHIFT_SUMMARY_REQUEST';
export const REPORTS_SHIFTS_LIST_SHIFT_REQUEST =
  'REPORTS_SHIFTS_LIST_SHIFT_REQUEST';
export const REPORTS_SHIFTS_PAGE_REQUEST = 'REPORTS_SHIFTS_PAGE_REQUEST';
export const REPORTS_SHIFTS_EXPORT_SHIFT_REQUEST =
  'REPORTS_SHIFTS_EXPORT_SHIFT_REQUEST';
export const REPORTS_SHIFTS_DETAILS_REQUEST = 'REPORTS_SHIFTS_DETAILS_REQUEST';
export const REPORTS_SHIFTS_SUMMARY_LOAD_MORE_DATA =
  'REPORTS_SHIFTS_SUMMARY_LOAD_MORE_DATA';

/** **************************************
 * On Change handler
 *************************************** */
export const REPORTS_SHIFTS_CHANGE_DATE = 'REPORTS_SHIFTS_CHANGE_DATE';
export const REPORTS_SHIFTS_CHANGE_OUTLET = 'REPORTS_SHIFTS_CHANGE_OUTLET';
export const REPORTS_SHIFTS_SET_CURRENT_PAGE =
  'REPORTS_SHIFTS_SET_CURRENT_PAGE';

/** **************************************
 * Setter
 *************************************** */
export const REPORTS_SHIFTS_SET_SHIFT_SUMMARY =
  'REPORTS_SHIFTS_SET_SHIFT_SUMMARY';
export const REPORTS_SHIFTS_SET_LIST_SHIFT = 'REPORTS_SHIFTS_SET_LIST_SHIFT';
export const REPORTS_SHIFTS_SET_START_END_DATE =
  'REPORTS_SHIFTS_SET_START_END_DATE';
export const REPORTS_SHIFTS_SET_SHIFT_DETAILS =
  'REPORTS_SHIFTS_SET_SHIFT_DETAILS';
export const REPORTS_SHIFTS_SET_OUTLETS = 'REPORTS_SHIFTS_SET_OUTLETS';
export const REPORTS_SHIFTS_DETAIL_HIDE = 'REPORTS_SHIFTS_DETAIL_HIDE';
export const REPORTS_SHIFTS_SET_PAYMENT_METHOD_CATEGORIES =
  'REPORTS_SHIFTS_SET_PAYMENT_METHOD_CATEGORIES';
